import styled from 'styled-components';
import { Button, Tooltip } from 'antd';
import { ColorMenu, EmbedsMenu, FormattingMenu, ListingMenu, TextStylesMenu } from './menu';
import { styleVariables } from '../../../style';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledMenuBarContainer = styled.div.withConfig({
  displayName: "menu-editorcomponent__StyledMenuBarContainer",
  componentId: "sc-120g5zt-0"
})(["display:flex;flex-wrap:wrap;gap:", ";padding:", ";border:", " solid ", ";border-top-left-radius:", ";border-top-right-radius:", ";background-color:", ";"], styleVariables.gap.medium, styleVariables.padding.medium, styleVariables.borderWidth.small, styleVariables.colors.gray6, styleVariables.borderRadius.medium, styleVariables.borderRadius.medium, styleVariables.colors.gray3);
var StyleButtonGroup = styled.div.withConfig({
  displayName: "menu-editorcomponent__StyleButtonGroup",
  componentId: "sc-120g5zt-1"
})(["display:flex;flex-wrap:wrap;gap:", ";align-items:center;justify-content:center;"], styleVariables.gap.medium);
/**
 * Default order của menu groups
 */

var DEFAULT_MENU_GROUPS_ORDER = ['text-styles', 'formatting', 'color', 'listing', 'embeds'];
/**
 * Render menu group theo type
 */

var renderMenuGroup = function renderMenuGroup(type, editor, labels, addImage, addAudio, hideMath) {
  switch (type) {
    case 'text-styles':
      return /*#__PURE__*/_jsx(TextStylesMenu, {
        editor: editor,
        labels: labels
      });

    case 'formatting':
      return /*#__PURE__*/_jsx(FormattingMenu, {
        editor: editor,
        labels: labels
      });

    case 'color':
      return /*#__PURE__*/_jsx(ColorMenu, {
        editor: editor,
        labels: labels
      });

    case 'listing':
      return /*#__PURE__*/_jsx(ListingMenu, {
        editor: editor,
        labels: labels
      });

    case 'embeds':
      return /*#__PURE__*/_jsx(EmbedsMenu, {
        editor: editor,
        addImage: addImage,
        addAudio: addAudio,
        labels: labels,
        hideMath: hideMath
      });

    default:
      return null;
  }
};

export var MenuEditor = function MenuEditor(_ref) {
  var editor = _ref.editor,
      addImage = _ref.addImage,
      addAudio = _ref.addAudio,
      labels = _ref.labels,
      _ref$customMenuItems = _ref.customMenuItems,
      customMenuItems = _ref$customMenuItems === void 0 ? [] : _ref$customMenuItems,
      _ref$menuGroupsOrder = _ref.menuGroupsOrder,
      menuGroupsOrder = _ref$menuGroupsOrder === void 0 ? DEFAULT_MENU_GROUPS_ORDER : _ref$menuGroupsOrder,
      hideMath = _ref.hideMath;

  if (!editor) {
    return null;
  } // Sử dụng menuGroupsOrder hoặc default


  var order = menuGroupsOrder.length > 0 ? menuGroupsOrder : DEFAULT_MENU_GROUPS_ORDER;
  return /*#__PURE__*/_jsx(StyledMenuBarContainer, {
    children: /*#__PURE__*/_jsxs(StyleButtonGroup, {
      children: [order.map(function (type, index) {
        var menuGroup = renderMenuGroup(type, editor, labels, addImage, addAudio, hideMath);
        if (!menuGroup) return null;
        return /*#__PURE__*/_jsx(React.Fragment, {
          children: menuGroup
        }, type);
      }), customMenuItems.length > 0 && /*#__PURE__*/_jsx(_Fragment, {
        children: customMenuItems.map(function (item, index) {
          return /*#__PURE__*/_jsx(React.Fragment, {
            children: /*#__PURE__*/_jsx(Tooltip, {
              title: item.label,
              children: /*#__PURE__*/_jsx(Button, {
                icon: item.icon,
                onClick: function onClick() {
                  return item.onClick(editor);
                },
                type: "text",
                className: "custom-menu-item-".concat(item.key),
                children: item.label
              })
            })
          }, item.key);
        })
      })]
    })
  });
};